/* Services mega menu (Fat Buddha, 2026-10-03): hover, click and keyboard behaviour. */
if (!customElements.get('fb-mega-menu')) {
  class FbMegaMenu extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.fb-mega__trigger');
      this.panel = this.querySelector('.fb-mega__panel');
      this.item = this.closest('li') || this;
      if (!this.trigger || !this.panel) return;

      this.desktopQuery = window.matchMedia('(min-width: 1100px)');
      this.closeTimer = null;
      this.openedByHover = 0;

      this.onEnter = (event) => {
        if (event.pointerType !== 'mouse' || !this.desktopQuery.matches) return;
        clearTimeout(this.closeTimer);
        if (!this.isOpen()) {
          this.open();
          this.openedByHover = Date.now();
        }
      };
      this.onLeave = (event) => {
        if (event.pointerType !== 'mouse') return;
        clearTimeout(this.closeTimer);
        this.closeTimer = setTimeout(() => {
          if (!this.contains(document.activeElement) || this.openedByHover) this.close();
        }, 200);
      };
      this.onClick = (event) => {
        event.preventDefault();
        // Clicking while it is hover-opened pins it open; otherwise click toggles
        if (this.isOpen() && this.openedByHover) {
          this.openedByHover = 0;
          return;
        }
        this.isOpen() ? this.close() : this.open();
        this.openedByHover = 0;
      };
      this.onTriggerKey = (event) => {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          this.open();
          this.openedByHover = 0;
          const first = this.panel.querySelector('a');
          if (first) first.focus();
        }
      };
      this.onKeydown = (event) => {
        if (event.key === 'Escape' && this.isOpen()) {
          event.preventDefault();
          this.close();
          this.trigger.focus();
        }
      };
      this.onFocusOut = (event) => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close();
      };
      this.onDocClick = (event) => {
        if (this.isOpen() && !this.contains(event.target)) this.close();
      };
      this.onReposition = () => {
        if (this.isOpen()) this.position();
      };
      this.onBreakpoint = () => {
        if (!this.desktopQuery.matches) this.close();
      };
      this.onBlockSelect = (event) => {
        const ids = (this.dataset.blockIds || '').split(',');
        if (event.detail && ids.includes(event.detail.blockId)) {
          this.open();
          this.openedByHover = 0;
        }
      };
      this.onBlockDeselect = (event) => {
        const ids = (this.dataset.blockIds || '').split(',');
        if (event.detail && ids.includes(event.detail.blockId)) this.close();
      };

      this.item.addEventListener('pointerenter', this.onEnter);
      this.item.addEventListener('pointerleave', this.onLeave);
      this.trigger.addEventListener('click', this.onClick);
      this.trigger.addEventListener('keydown', this.onTriggerKey);
      this.addEventListener('keydown', this.onKeydown);
      this.addEventListener('focusout', this.onFocusOut);
      document.addEventListener('click', this.onDocClick);
      window.addEventListener('resize', this.onReposition);
      window.addEventListener('scroll', this.onReposition, { passive: true });
      this.desktopQuery.addEventListener('change', this.onBreakpoint);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    disconnectedCallback() {
      if (!this.trigger) return;
      this.item.removeEventListener('pointerenter', this.onEnter);
      this.item.removeEventListener('pointerleave', this.onLeave);
      document.removeEventListener('click', this.onDocClick);
      window.removeEventListener('resize', this.onReposition);
      window.removeEventListener('scroll', this.onReposition);
      this.desktopQuery.removeEventListener('change', this.onBreakpoint);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      this.setOverlay(false);
    }

    isOpen() {
      return this.classList.contains('is-open');
    }

    position() {
      const header =
        this.closest('.header-wrapper') ||
        document.querySelector('.shopify-section-header');
      const bottom = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
      this.panel.style.setProperty('--fb-mega-top', `${bottom}px`);
    }

    setOverlay(visible) {
      const overlay = document.querySelector('.header__overlay');
      if (overlay) overlay.classList.toggle('visible', visible);
    }

    open() {
      this.position();
      this.classList.add('is-open');
      this.trigger.setAttribute('aria-expanded', 'true');
      this.setOverlay(true);
    }

    close() {
      clearTimeout(this.closeTimer);
      this.openedByHover = 0;
      if (!this.isOpen()) return;
      this.classList.remove('is-open');
      this.trigger.setAttribute('aria-expanded', 'false');
      this.setOverlay(false);
    }
  }

  customElements.define('fb-mega-menu', FbMegaMenu);
}

/* Drawer: after Escape closes the menu drawer, return focus to the menu button
   (the theme otherwise leaves focus on <body>). */
document.addEventListener('keyup', (event) => {
  if (event.key !== 'Escape') return;
  const drawer = document.querySelector('header-drawer > details');
  if (!drawer || !drawer.querySelector('.fb-mega-drawer--flat')) return;
  if (!drawer.contains(event.target)) return;
  // The theme's own handler runs first and starts the close (removes .menu-opening);
  // the open attribute is only removed after the closing animation.
  setTimeout(() => {
    if (drawer.classList.contains('menu-opening')) return;
    const active = document.activeElement;
    if (active && active !== document.body && !drawer.contains(active)) return;
    const summary = drawer.querySelector(':scope > summary');
    if (summary) summary.focus({ preventScroll: true });
  }, 0);
});
